import React from 'react';
import PropTypes from 'prop-types';
import useWindowSize from '../../../../customHooks/useWindowSize';
import MobileMenuItem from './MobileMenuItem';
import CardButton from './CardButton';
import { connect } from 'react-redux';
import { getDocuments } from '../../../../actions';

const DocumentMenu = (props) => {
  const { document } = props;
  const windowSize = useWindowSize();
  const DESKTOP_WIDTH = 1330;

  return (
    <>
      {
        windowSize.width >= DESKTOP_WIDTH
          ? <CardButton
            document={document}
          />
          : <MobileMenuItem
            document={document}
          />
      }
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDocuments: () =>
      dispatch(getDocuments())
  };
};

DocumentMenu.propTypes = {
  document: PropTypes.object.isRequired
};

export default connect(null, mapDispatchToProps)(DocumentMenu);
